import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Endpoints`}</h2>
    <p>{`If you want to see these endpoints in action before getting started, you can use our `}<a parentName="p" {...{
        "href": "https://developers.giphy.com/explorer/"
      }}>{`API Explorer`}</a>{` to input sample queries and view the live responses!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      